import { Debt } from "../../lib/types";
import { debtAPI } from "../api/api";

// Database operations for Debt - API client implementation
const debtDB = {
  getAllDebts: async (): Promise<Debt[]> => {
    try {
      return await debtAPI.getAll();
    } catch (error) {
      console.error("Error getting all debts:", error);
      return [];
    }
  },

  getDebtById: async (id: string): Promise<Debt | null> => {
    try {
      return await debtAPI.getById(id);
    } catch (error) {
      console.error(`Error getting debt with id ${id}:`, error);
      return null;
    }
  },

  addDebt: async (debt: Omit<Debt, "id">): Promise<Debt> => {
    try {
      return await debtAPI.add(debt);
    } catch (error) {
      console.error("Error adding debt:", error);
      throw error;
    }
  },

  updateDebt: async (debt: Debt): Promise<Debt> => {
    try {
      return await debtAPI.update(debt);
    } catch (error) {
      console.error("Error updating debt:", error);
      throw error;
    }
  },

  deleteDebt: async (id: string): Promise<void> => {
    try {
      await debtAPI.delete(id);
    } catch (error) {
      console.error("Error deleting debt:", error);
      throw error;
    }
  },

  importInitialData: async (debts: Omit<Debt, "id">[]): Promise<Debt[]> => {
    try {
      return await debtAPI.importInitialData(debts);
    } catch (error) {
      console.error("Error importing debts:", error);
      throw error;
    }
  },
};

export default debtDB;
